"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Video = _interopRequireDefault(require("./Video"));

var _HamburgerIconTheater = _interopRequireDefault(require("./HamburgerIconTheater.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var classNames = require("classnames");

var Overlay = /*#__PURE__*/function (_React$Component) {
  _inherits(Overlay, _React$Component);

  var _super = _createSuper(Overlay);

  function Overlay(props) {
    var _this;

    _classCallCheck(this, Overlay);

    _this = _super.call(this, props);
    _this.state = {
      width: 0,
      height: 0
    };
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Overlay, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.isClosing) {
        document.documentElement.classList.remove("theater-is-open");
      } else if (this.props.isOpen) {
        document.documentElement.classList.add("theater-is-open");
      }
    }
  }, {
    key: "updateWindowDimensions",
    value: function updateWindowDimensions() {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight
      });
    } // Generates keyframe style tag to be document.head.appendChild'ed;

  }, {
    key: "generateKeyframesStyle",
    value: function generateKeyframesStyle(width, height, modifier) {
      var radius = 5000;

      if (width > height) {
        radius = width;
      } else if (width < height) {
        radius = height;
      } else {
        radius = width;
      } // 2 is too low


      if (!modifier) {
        modifier = 3;
      }

      radius = radius * modifier;
      return "\n      @keyframes menuAnimOpenBottomLeft {\n        0% {\n          top: unset;\n          bottom: ".concat(-0.5 * radius, "px;\n          left: ").concat(-0.5 * radius, "px;\n          width: 0;\n          height: 0;\n          border-radius: 50%;\n        }\n        100% {\n          top: unset;\n          bottom: ").concat(-0.5 * radius, "px;\n          left: ").concat(-0.5 * radius, "px;\n          width: ").concat(radius, "px;\n          height: ").concat(radius, "px;\n          border-radius: 50%;\n        }\n      }\n      @keyframes menuAnimCloseBottomLeft {\n        0% {\n          top: unset;\n          bottom: ").concat(-0.5 * radius, "px;\n          left: ").concat(-0.5 * radius, "px;\n          width: ").concat(radius, "px;\n          height: ").concat(radius, "px;\n          border-radius: 50%;\n        }\n        100% {\n          top: unset;\n          bottom: ").concat(-0.5 * radius, "px;\n          left: ").concat(-0.5 * radius, "px;\n          width: 0;\n          height: 0;\n          border-radius: 50%;\n        }\n      }");
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateWindowDimensions();
      window.addEventListener("resize", this.updateWindowDimensions);
      var menuKeyframes = this.generateKeyframesStyle(window.innerWidth, window.innerHeight); // TO-DO: Check if animation style already exists from a previous video component, if so, do not add another identical style tag to document head

      var $style = document.createElement("style");
      $style.innerHTML = menuKeyframes;
      document.head.appendChild($style);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.updateWindowDimensions);
    }
  }, {
    key: "render",
    value: function render() {
      var iconColor = "#6d6e6f";
      var iconClass = classNames({
        "theater-icon": true,
        open: this.props.isOpen
      }); //   if (this.props.atTopOfPage) {
      //   iconColor = "white"
      // }

      var containerClasses = classNames(this.props.className, {
        "theater-container": true
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: containerClasses
      }, /*#__PURE__*/_react["default"].createElement(_Video["default"], {
        toggleTheater: this.props.toggleTheater,
        isOpen: this.props.isOpen,
        isClosing: this.props.isClosing,
        isOpening: this.props.isOpening,
        key: this.props.compId,
        videoUrl: this.props.videoUrl,
        controls: this.props.controls,
        playing: this.props.playing,
        compId: this.props.compId
      }), this.props.isOpen && /*#__PURE__*/_react["default"].createElement(_HamburgerIconTheater["default"], {
        toggleTheater: this.props.toggleTheater,
        className: iconClass,
        color: iconColor,
        isOpen: this.props.isOpen,
        isClosing: this.props.isClosing,
        isOpening: this.props.isOpening,
        ext: this.props.ext,
        compId: this.props.compId
      }));
    }
  }]);

  return Overlay;
}(_react["default"].Component);

Overlay.propTypes = {
  isOpen: _propTypes["default"].bool,
  isOpening: _propTypes["default"].bool,
  isClosing: _propTypes["default"].bool,
  toggleTheater: _propTypes["default"].func,
  videoUrl: _propTypes["default"].string,
  controls: _propTypes["default"].bool,
  playing: _propTypes["default"].bool
};
var _default = Overlay;
exports["default"] = _default;

//# sourceMappingURL=Overlay.js.map